import mentionableView from './mentionableComponent.html';
import './mentionableComponent.css';
import { CaretManagerInput } from 'components/sharpr/caretManager/input/CaretManagerInputClass';
import { CaretManagerQuill } from 'components/sharpr/caretManager/quill/CaretManagerQuillClass';
import { ensure } from 'components/sharpr/ensure/ensure';
import { regexQuote } from 'components/sharpr/regexQuote/regexQuote';
import _ from 'lodash';

export function mentionableComponent() {
	return {
		bindings: {
			handlers: '<?',
			onBeforeReplace: '<?',
			onAfterReplace: '<?',
			minChars: '<?',
			maxItems: '<?',
			caseSensitive: '<?',
			alignWith: '@?',
			// TODO: support
			fly: '@?',
		},
		transclude: true,
		controllerAs: 'vm',
		controller: mentionableComponentCtrl,
		template: mentionableView,
	};
}

export class mentionableComponentCtrl {
	constructor($element, $timeout) {
		'ngInject';
		this.$element = $element;
		this.$timeout = $timeout;
		this.suggestions = [];
		this.suggPosition = {};
		this.alignWith = this.alignWith || 'cursor';
		this.minChars = this.minChars || 2;
		this.maxItems = this.maxItems || 10;
	}

	$postLink() {
		this.input = angular.element(this.$element[0].querySelector('textarea, input, [contenteditable]'));
		if (this.input[0].contentEditable == 'true') {
			this.caret = new CaretManagerQuill(this.input[0], this);
		} else {
			this.caret = new CaretManagerInput(this.input[0]);
		}
		const buildSuggestions = this.buildSuggestions.bind(this);
		const navigateSuggestions = this.navigateSuggestions.bind(this);
		const chooseSuggestion = this.chooseSuggestion.bind(this);
		const clearSuggestions = this.clearSuggestions.bind(this);
		const buildThrottled = angular.mock
			? buildSuggestions
			: _.throttle(buildSuggestions, { leading: true, trailing: true }, 100);
		this.input.on('keydown', navigateSuggestions);
		this.input.on('keydown', chooseSuggestion);
		this.input.on('input', buildThrottled);
		this.input.on('mouseup', buildSuggestions);
		this.input.on('focusout', clearSuggestions);
		this.input.on('scroll', clearSuggestions);
	}

	clearSuggestions() {
		this.$timeout(() => (this.suggestions = []), 300);
	}

	buildSuggestions() {
		let word = this.caret.getWord();
		// console.log('buildSuggestions', word);
		if (!word || word.length < this.minChars) {
			this.suggPosition = {};
			this.suggestions = [];
			return;
		}
		this.runHandlers(word).then(suggestions => {
			this.suggestions = ensure.array(suggestions);
			if (this.suggestions.length === 0) {
				this.activeItem = null;
				this.suggPosition = {};
			} else {
				this.positionSuggestions();
				if (this.suggestions.indexOf(this.activeItem) == -1) {
					// auto select first choice
					this.activeItem = this.suggestions[0];
				}
			}
			// paint suggestions
			this.$timeout(() => {});
		});
	}

	positionSuggestions() {
		const styles = this.caret.getWordSuggestionPosition(this.$element[0]);
		if (this.alignWith == 'left') {
			styles.left = '1px';
		}
		this.suggPosition = styles;
	}

	runHandlers(word) {
		let promise;
		this.handlers.some(handler => {
			if (handler.match.test(word)) {
				if (handler.items) {
					promise = Promise.resolve(this.filterItems(handler.items, word));
				} else if (handler.provider) {
					promise = ensure.promise(handler.provider(word));
				}
				return true;
			}
		});
		return promise || Promise.resolve([]);
	}

	filterItems(items, word) {
		if (!items.length) {
			return [];
		}
		let matcher = new RegExp(regexQuote(word), this.caseSensitive ? undefined : 'i');
		if (typeof items[0] == 'string') {
			return items
				.filter(item => {
					return matcher.test(item);
				})
				.map(text => {
					return { $find: text };
				});
		}
		return items.filter(item => {
			return matcher.test(item.$find);
		});
	}

	navigateSuggestions(event) {
		if (this.suggestions.length === 0) {
			return;
		}
		// console.log('navigate suggestions key', event.which);
		if (event.which == 38 || event.which == 40) {
			event.preventDefault();
			// up or down
			let pos = this.activeItem ? this.suggestions.indexOf(this.activeItem) : -1;
			pos += event.which == 38 ? -1 : 1;
			if (pos < 0) {
				pos = this.suggestions.length - 1;
			}
			if (pos > this.suggestions.length - 1) {
				pos = 0;
			}
			this.activeItem = this.suggestions[pos];
			this.$timeout(() => {});
		}
	}

	chooseSuggestion(event) {
		// console.log('chooseSuggestion key', event.which, this.activeItem);
		// TODO: fix bug where if you press enter following a replacement, it will replace again
		if (event.which == 13 && this.activeItem) {
			// console.log('chooseSuggestion', event);
			event.preventDefault();
			event.stopImmediatePropagation();
			event.stopPropagation();
			this.replaceWord(this.activeItem);
		}
	}

	replaceWord(item) {
		let newWord;
		if (this.onBeforeReplace) {
			newWord = this.onBeforeReplace(item);
		} else {
			newWord = item.$replace || item.$find;
		}
		if (newWord && newWord.length) {
			this.caret.setWord(newWord);
		} else {
			this.caret.setWord('');
		}
		if (this.onAfterReplace) {
			this.onAfterReplace({
				newWord: newWord,
				item: item,
				input: this.input,
			});
		}
		this.input[0].focus();
		if (this.input[0].reinitAutosize) {
			this.input[0].reinitAutosize();
		}
		this.input.triggerHandler('input'); // trigger ng-model
		this.activeItem = null;
		this.suggPosition = {};
		this.suggestions = [];
		// hide suggestions
		this.$timeout(() => {});
	}
}
